export default __webpack_public_path__ + "static/media/Boots of the Ecliptic.bd7cf779.jpg";